import React, {useState, useEffect} from 'react';
import axios from '../Common/axios';
import {Table, Select, Divider, Modal} from "antd";
import {getFindAnalysisList, getFindReportIdInfo, getFindVulnerablityStatistics} from '../Common/api';
import {getGridTableHeight, getAssetTypeTitle, amountFormatter, floatFormatter} from '../Common/util';
import {Chart04} from './Chart';

const {Option} = Select;

/** -------------------------------------------------------------------------- **/
function Item({itemList, sumData, companyCode, assetType, reportId, reportName}) {

    const [compareReportId, setCompareReportId] = useState('');
    const [compareReportName, setCompareReportName] = useState('');
    const [reportIdOption, setReportIdOption] = useState([]);
    const [compareItemList, setCompareItemList ] = useState([]);
    const [compareMeasureList, setCompareMeasureList] = useState([]);
    const [compareReportList, setCompareReportList] = useState([]);
    const [loadingFlag, setLoadingFlag] = useState(false);

    // 비교대상 레포트 조회
    useEffect(() => {
        findCompareReport(companyCode, assetType);
    }, [companyCode, assetType]);

    const findCompareReport = (companyCode, assetType) => {
        //자동조회
        if(companyCode != '' && assetType != '') {
            axios.get(getFindAnalysisList(companyCode, assetType, '', '', ''))
                .then((response) => {
                    //console.log(response);
                    setReportIdOption(response.data);
                    setCompareReportId(response.data[0].report_id);
                })
                .catch((error) => {
                    console.log("Compare.js ------- 35 에러");
                    console.dir(error);
                });
        }
    }
    
    // 비교대상 취약점진단 결과 조회
    const onChangeCompareReportId = (value) => {
        setLoadingFlag(true);
        setCompareReportId(value);
        findCompareReportList(value);
    };
    
    // 비교대상 레포트 조회
    const findCompareReportList = (compareReportId) => {
        let titleName="리포트 조회";
        if(compareReportId) {
            axios.get(getFindReportIdInfo(compareReportId))
                .then((response) => {
                    //setAssetType(response.data[0].asset_type);
                    setCompareReportName(response.data[0].report_nm);
                    //setReportId(response.data[0].report_id);
                })
                .catch((error) => {
                    setLoadingFlag(false);
                    console.log("Compare.js ------- 59 에러");
                    console.dir(error);
                });

            //통계 조회(초기화 후 조회)
            setCompareItemList([]);
            setCompareMeasureList([]);

            axios.get(getFindVulnerablityStatistics(compareReportId, 'C'))
                .then((response) => {
                    //console.log(response);
                    const mapped = response.data.statistic_root.map((e, i) => {
                        return { index: i, value: e.measure_cd };
                    });
                    // console.dir(mapped);
                    // console.log("mapped----------------------------------73");
                    setCompareItemList(response.data.statistic_root);
                    setCompareMeasureList(response.data.statistic_measure);
                    //setAssetList(response.data.statistic_asset);                    
                    setLoadingFlag(false);
                })
                .catch((error) => {
                    
                    setLoadingFlag(false);
                    Modal.error({title:titleName, content:"이전 데이터가 없거나 잘못된 데이터로 오류가 발생했습니다.", okText:"Close"});
                });
        }
    }

    const [compareSumData, setCompareSumData] = useState({total : 0, check : 0, Y : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0});

    //테이블 데이타 구하기
    useEffect(() => {
        // 비교대상 레포트의 칼럼ID변경
        const newData = compareItemList.map(item => {
            const newKeys = Object.keys(item).reduce((acc, key) => {
              acc[`bf_${key}`] = item[key];
              return acc;
            }, {});
            return newKeys;
        });

        // 2개의 ReportList 합치기
        const mergedReportList = itemList.map(item => ({
            ...item,
            ...newData.find(x => x.bf_measure_cd == item.measure_cd)
        }));

        setCompareReportList(mergedReportList);

      }, [compareItemList]);

      // 비교대상 합계 구하기
      useEffect(() => {
        let s_data = {total : 0, check : 0, Y : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0};
        compareMeasureList.map(curr => {
            s_data.total = s_data.total + curr.total;
            s_data.check = s_data.total + curr.check;
            s_data.Y = s_data.Y + curr.Y;
            s_data.N = s_data.N + curr.N;
            s_data.P = s_data.P + curr.P;
            s_data.NA = s_data.NA + curr.NA;
            s_data.total_score = s_data.total_score + curr.total_score;
            s_data.eval_score = s_data.eval_score + curr.eval_score;
            return s_data;
        });
        if(s_data.total_score > 0) {
            s_data.level = (s_data.eval_score /  s_data.total_score) * 100;
        }
        setCompareSumData(s_data);
      }, [compareMeasureList]);


      // 취약점진단 항목별 년도 통계
    const compareColumnData =  [
        {
            title: '구분',
            align: 'center',
            colSpan: 4,
            children: [
            {
                title: '분류',
                align: 'center',
                colSpan: 2,
                rowSpan: 2,
                children: [
                    {
                        title: ' ',
                        dataIndex: 'measure_type',
                        key: 'measure_type',
                        width: '50px',
                        align: 'center',
                        fixed: 'left',
                        // render: (value, row, index) => {
                        //     const obj = {
                        //         children : value,
                        //         props : {},
                        //     }
                        //     if(index >- 1 && value == itemList[index - 1]?.measure_type) {
                        //         obj.props.rowSpan = 0;
                        //     } else {
                        //         for (
                        //             let i = 0;
                        //             index + i != itemList.length &&
                        //             value == itemList[index + i]?.measure_type;
                        //             i += 1
                        //         ) {
                        //             obj.props.rowSpan = i + 1;
                        //         }
                        //     }
                        //     return obj;
                        // },
                        render: (value, row, index) => {
                            return value;
                        },
                        onCell: (record, index) => {
                            const value = record.measure_type; // 또는 해당하는 필드명
                            
                            if(index >= 1 && value == itemList[index - 1]?.measure_type) {
                                return {
                                    rowSpan: 0
                                };
                            } else {
                                let rowSpan = 1;
                                for (
                                    let i = 1;
                                    index + i < itemList.length &&
                                    value == itemList[index + i]?.measure_type;
                                    i += 1
                                ) {
                                    rowSpan = i + 1;
                                }
                                return {
                                    rowSpan: rowSpan
                                };
                            }
                        },                     
                        colSpan: 0,
                    },
                    {
                        title: ' ',
                        dataIndex: 'measure_cd',
                        key: 'measure_cd',
                        width: '70px',
                        align: 'center',
                        fixed: 'left',
                        colSpan: 0,
                    },
                ]
            },
            {
                title: '진단 항목',
                dataIndex: 'measure_nm',
                key: 'measure_nm',
                width: '180px',
                align: 'left',
                fixed: 'left',
                rowSpan: 2,
                ellipsis : false,

            },
            {
                title: '중요도',
                dataIndex: 'important_grd',
                key: 'important_grd',
                width: '50px',
                align: 'center',
                ellipsis : true,
                rowSpan: 2,
                fixed: 'left',
            },
        ]},
        {
            title: compareReportName==""?"자료없음":compareReportName,
            align: 'center',
            className: 'fix_col',
            children: [
            {
                title: '등급 통계',
                align: 'center',
                className: 'fix_col',
                children: [
                    {
                        title: '전체',
                        dataIndex: 'bf_stat_measure_total',
                        key: 'bf_stat_measure_total',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '양호',
                        dataIndex: 'bf_stat_measure_Y',
                        key: 'bf_stat_measure_Y',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '취약',
                        dataIndex: 'bf_stat_measure_N',
                        key: 'bf_stat_measure_N',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '부분이행',
                        dataIndex: 'bf_stat_measure_P',
                        key: 'bf_stat_measure_P',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '해당없음',
                        dataIndex: 'bf_stat_measure_NA',
                        key: 'bf_stat_measure_NA',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                ]
            },
            {
                title: '중요도 점수',
                align: 'center',
                className: 'fix_col',
                children: [
                    {
                        title: '전체',
                        dataIndex: 'bf_stat_total_score',
                        key: 'bf_stat_total_score',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '평가',
                        dataIndex: 'bf_stat_eval_score',
                        key: 'bf_stat_eval_score',
                        width: '50px',
                        align: 'center',
                        className: 'fix_col',
                    },
                    {
                        title: '보안수준',
                        key: 'bf_stat_level',
                        width: '60px',
                        align: 'center',
                        className: 'fix_col',
                        render: (_ , rowData ) => {
                            if(rowData.bf_stat_total_score>0) {
                                return (
                                    <>
                                        {floatFormatter((rowData.bf_stat_eval_score/rowData.bf_stat_total_score) * 100,1)}%
                                    </>
                                );
                            } else {
                                return (
                                    <>N/A</>
                                );
                            }
                        },
                    },
                ]
            },
        ]},
        {
            title: reportName,
            align: 'center',
            children: [
            {
                title: '등급 통계',
                align: 'center',
                children: [
                    {
                        title: '전체',
                        dataIndex: 'stat_measure_total',
                        key: 'stat_measure_total',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '양호',
                        dataIndex: 'stat_measure_Y',
                        key: 'stat_measure_Y',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '취약',
                        dataIndex: 'stat_measure_N',
                        key: 'stat_measure_N',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '부분이행',
                        dataIndex: 'stat_measure_P',
                        key: 'stat_measure_P',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '해당없음',
                        dataIndex: 'stat_measure_NA',
                        key: 'stat_measure_NA',
                        width: '50px',
                        align: 'center',
                    },
                ]
            },
            {
                title: '중요도 점수',
                align: 'center',
                children: [
                    {
                        title: '전체',
                        dataIndex: 'stat_total_score',
                        key: 'stat_total_score',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '평가',
                        dataIndex: 'stat_eval_score',
                        key: 'stat_eval_score',
                        width: '50px',
                        align: 'center',
                    },
                    {
                        title: '보안수준',
                        key: 'stat_level',
                        width: '60px',
                        align: 'center',
                        // render: (_ , rowData ) => {
                        //     if(rowData.stat_total_score>0) {
                        //         return (
                        //             <>
                        //                 {floatFormatter((rowData.stat_eval_score/rowData.stat_total_score) * 100,1)}%
                        //             </>
                        //         );
                        //     } else {
                        //         return (
                        //             <>N/A</>
                        //         );
                        //     }
                        // },
                        render: (_, rowData) => {
                            return rowData.stat_total_score > 0 
                                ? `${floatFormatter((rowData.stat_eval_score / rowData.stat_total_score) * 100, 1)}%`
                                : 'N/A';
                        }
                    },
                ]
            },
        ]},
    ];
    
    return (
        <>
            <div id="divTabs3" className="section" style={{height:getGridTableHeight(210), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 취약점진단 항목별 년도 통계'}
                            <Select id="compareReportId"
                                    size="small"
                                    dropdownMatchSelectWidth={false}
                                    style={{width: 'auto', minWidth: '600px', marginLeft: "20px"}}
                                    onChange={onChangeCompareReportId}
                            >
                                {reportIdOption.length > 0 &&
                                    reportIdOption.map((item, i) => {
                                        return (
                                            <Option key={i} value={item.report_id}>{item.report_nm}({item.report_id})</Option>
                                        )
                                    })}
                            </Select>
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table columns={compareColumnData}
                        dataSource={compareReportList}
                        pagination={false}
                        loading={loadingFlag}
                        bordered size={"small"}
                        style={{'--border-color': '#ececec', }}
                        className="sub_table"
                        scroll={{x: '100%'}}
                        rowKey='measure_cd'
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={4} className={'sum_col'}>{'합계'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4} className={'sum_col'}>{amountFormatter(compareSumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5} className={'sum_col'}>{amountFormatter(compareSumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(compareSumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(compareSumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(compareSumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{amountFormatter(compareSumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{amountFormatter(compareSumData.eval_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={11}>{floatFormatter(compareSumData.level,1)}%</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4} className={'sum_col'}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5} className={'sum_col'}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={11}>{floatFormatter(sumData.level,1)}%</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 항목별 년도 비교 보안수준'}
                </div>
                <div style={{padding: '5px 10px', height: '200px'}}>
                    <Chart04 dataList={compareReportList} sumData={compareSumData} />
                </div>
            </div>
        </>
    );
}
export default Item;